import type { Maybe } from '@/types/globals';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';

export class ApplianceDetailsUtils {
	public static isApplianceDetailsEnabled(procedureId: Maybe<number>): boolean {
		return procedureId === ProcedureEnum.Appliance;
	}

	public static isApplianceDetailsEnabledForLabAndPrintRx(
		procedureId: number,
		applianceUpperValue: boolean,
		applianceLowerValue: boolean,
		applianceTypeValue: number
	): boolean {
		return (
			(procedureId as ProcedureEnum) === ProcedureEnum.Appliance &&
			(applianceUpperValue || applianceLowerValue || applianceTypeValue !== 0)
		);
	}
}
